module.exports = __webpack_public_path__ + "assets/platform-avatar1.aadfa055.svg";